<template>
  <div>
    <template v-if="typeof model === 'object'">
      <div
        v-for="(model_, i) in model"
        :key="i"
        class="sub"
      >
        <template v-if="typeof model_ === 'object'">
          <template v-if="model_.type === 'Object'">
            <v-checkbox
              :input-value="(typeof permission[i] === 'object')"
              @change="e => setObject(e, i)"
              :label="model_.title"
              :class="(typeof permission[i] === 'object' ? 'selected' : '')"
              hide-details
            ></v-checkbox>
            <template v-if="typeof permission[i] === 'object'">
              <slot
                name="sub"
                :model="model_"
                :permission="permission[i]"
                :update="e => update(e, i)"
              ></slot>
            </template>
          </template>
          <template v-else-if="model_.type === 'Boolean'">
            <v-checkbox
              :input-value="(typeof permission[i] !== 'undefined' && permission[i])"
              @change="e => setBoolean(e, i)"
              :label="model_.title"
              :class="(typeof permission[i] !== 'undefined' && permission[i] ? 'selected' : '')"
              hide-details
            ></v-checkbox>
          </template>
          <template v-else-if="model_.type === 'Number'">
            <v-text-field
              :value="(typeof permission[i] !== 'undefined' && permission[i] !== false ? permission[i] : 0)"
              @change="e => setNumber(e, i)"
              :label="model_.title"
              type="number"
              filled
              hide-details
            ></v-text-field>
          </template>
          <template v-else-if="model_.type === 'Select'">
            <v-select
              :value="(typeof permission[i] !== 'undefined' ? permission[i] : 1)"
              @change="e => setSelect(e, i)"
              @input="e => setSelect(e, i)"
              :items="model_.options"
              :label="model_.title"
              item-text="title"
              item-value="id"
              auto-select-first
              filled
              hide-details
            />
          </template>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    model: {
      type: Object,
      required: true
    },
    value: {
      required: true
    }
  },
  computed: {
    permission: {
      get: function () {
        return this.value || {}
      },
      set: function (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    setObject (e, i) {
      // eslint-disable-next-line no-unused-vars
      let selects = Object.entries(this.model[i]).filter(([i_, e_]) => (e_.type === 'Select' || e_.type === 'Number')) || []
      let defaults = {}
      selects.forEach(function ([index]) {
        defaults[index] = 1
      })
      this.permission[i] = (e ? (Object.keys(defaults).length > 0 ? { ...defaults } : {}) : false)
      this.$forceUpdate()
    },
    setBoolean (e, i) {
      this.permission[i] = (e || false)
      this.$forceUpdate()
    },
    setNumber (e, i) {
      this.permission[i] = e || 0
      this.$forceUpdate()
    },
    setSelect (e, i) {
      this.permission[i] = e || 1
      this.$forceUpdate()
    },
    update (e, i) {
      console.log('permission', this.permission)
      this.permission[i] = e
      this.$forceUpdate()
    }
  }
}
</script>
